import styled from "styled-components";

export const StyledButtonContainer = styled.div`
  position: relative;
`;
